export const manifest = {
  screens: {
    scr_a3achi: { name: "Home", route: "/" },
  },
}
